import { render, staticRenderFns } from "./TableInquiry.vue?vue&type=template&id=51481182&scoped=true"
import script from "./TableInquiry.vue?vue&type=script&lang=js"
export * from "./TableInquiry.vue?vue&type=script&lang=js"
import style0 from "./TableInquiry.vue?vue&type=style&index=0&id=51481182&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51481182",
  null
  
)

export default component.exports